export default "__VITE_ASSET__CwQkuz7v__"